import styled, { css } from 'styled-components';

import { Media } from '../../assets/Mixins.style';

import {
  Inputbox as commonInputbox,
  Input as commonInput,
} from '../../assets/Common/Inputbox.style';

import { Button as commonButton } from '../../assets/Common/Button.style';

import {
  SelectionHolder as commonSectionHolder,
  Selection as commonSelection,
  SelectionInput as commonSectionInput,
  SelectionCheckmark as commonSectionCheckmark,
} from '../../assets/Common/Selection.style';

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  min-width: 429px;
  background: ${(props) => props.theme.background};
  border-left: 1px solid ${(props) => props.theme.border};
  z-index: 2;
  transition: 0.2s all;

  ${(props) =>
    props.isHide &&
    css`
      transform: translate(100%, 0);
    `}

  ${Media.sm`
    width: calc(100% - 60px);
    min-width: initial;
  `}
`;

export const Holder = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 25px;
  overflow-x: hidden;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.thumb};
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.track};
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  flex-shrink: 0;
  width: 100%;
  padding: 0 0 20px;
  border-bottom: 1px solid ${(props) => props.theme.border};
`;

export const Title = styled.h2`
  display: inline-block;
  color: ${(props) => props.theme.color};
  font-size: 26px;
  font-weight: 600;
  text-align: left;
  cursor: default;

  ${Media.lg`
    font-size: 22px;
  `}
`;

export const ToggleBox = styled.div`
  display: block;
  width: 60px;
  height: 50px;
  position: absolute;
  left: -60px;
  top: 129px;
  border-radius: 20px 0 0 20px;
  background: ${(props) => props.theme.background};
  border-top: 1px solid ${(props) => props.theme.border};
  border-bottom: 1px solid ${(props) => props.theme.border};
  border-left: 1px solid ${(props) => props.theme.border};
  box-shadow: 0 3px 6px 0 ${(props) => props.theme.shadow};

  ${(props) =>
    props.isToggle &&
    css`
      box-shadow: none;
    `}

  ${(props) =>
    props.isActive &&
    css`
      background: ${(props) => props.theme.backgroundOnActive};
    `}
`;

export const Toggle = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background: ${(props) => props.theme.background};
  color: ${(props) => props.theme.color};
  border: none;
  outline: none;
  cursor: pointer;

  ${(props) =>
    props.isActive &&
    css`
      color: ${(props) => props.theme.colorOnActive};
    `}

  svg path {
    fill: ${(props) => props.theme.color};

    ${(props) =>
      props.isActive &&
      css`
        fill: ${(props) => props.theme.colorOnActive};
      `}
  }
`;

export const Content = styled.div`
  display: block;
  width: 100%;
  padding: 0 0 20px;
  border-bottom: 1px solid ${(props) => props.theme.border};
`;

export const Footer = styled.div`
  display: block;
  width: 100%;
  padding: 20px 0 0;
`;

export const Grow = styled.div`
  flex-grow: 1;
`;

export const Button = styled.button`
  ${commonButton}
`;

export const Item = styled.div`
  position: relative;
  display: block;
  width: 100%;
  padding: 10px;
`;

export const Inputbox = styled.div`
  ${commonInputbox}
`;

export const Input = styled.input`
  ${commonInput}
`;

export const Info = styled.span`
  display: block;
  width: 75%;
  margin: 0 auto;
  font-size: 15px;
  line-height: 1.2;
  font-weight: 600;
  color: ${(props) => props.theme.color};
  text-align: center;
  cursor: default;
`;

export const ResetFilterButton = styled.a`
  position: absolute;
  top: 50%;
  right: -12px;
  display: none;
  align-items: center;
  justify-content: center;
  min-width: 25px;
  height: 25px;
  transform: translate(0, -50%);
  color: ${(props) => props.theme.color};
  transition: 0.2s color;
  user-select: none;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.colorOnHover};
  }

  ${(props) =>
    props.isVisible &&
    css`
      display: inline-flex;
    `}
`;

export const ResetFilterButtonIcon = styled.i`
  font-size: 20px;
  user-select: none;
`;

export const SelectionHolder = styled.div`
  ${commonSectionHolder}
`;

export const Selection = styled.span`
  ${commonSelection}
`;

export const SelectionInput = styled.input`
  ${commonSectionInput}
`;

export const SelectionCheckmark = styled.span`
  ${commonSectionCheckmark}
`;
